import useCases from '@/hooks/useCases';

import CasesSwitch from '@/components/cases/switch';

import Table from '@/components/Table/table';

const Cases = () => {
  const { data, loading, columns } = useCases();

  return (
    <div>
      <div className="flex items-center justify-center mt-6">
        <CasesSwitch />
      </div>

      {loading ? (
        <p className="text-center mt-4">Indlæser data...</p>
      ) : (
        <Table data={data} columns={columns} isSwitch={true} isImport={false} />
      )}
    </div>
  );
};

export default Cases;
